import React, { useState, useEffect } from 'react';
import { Dialog, DialogActions, DialogContent, Button, TextField, IconButton, Tooltip, Box, SelectChangeEvent, Chip, MenuItem, Select, FormControl, InputLabel, Paper } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { 
  getDocuments, addDocuments, editDocuments, editVehicle, getDriverName, getOwnerName, 
  addOwner, addOwnerDetails, deleteDocument, addWarehouseUserMapping, getWarehouseUserMapping, 
  deleteUserWarehousemapping, verifyOTP, deleteVehicle, activateVehicle, getWarehouseCompanyMapping, 
  getMakeModels, addInstitutionVehicleMapping, getCompanies, getInstitutions, getInstitutionVehicleMapping,
  editInstitutionVehicleMapping
} from './action.ts';
import AddOwnerModal from './add-owner-modal.tsx';
import ConfirmationPopup from '../../Components/ConfirmationModal/confirmation-modal.tsx';
import Heading from '../../Components/Heading/heading.tsx';
import UploadIcon from '@mui/icons-material/Upload';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from '@mui/icons-material/Delete';
import '../../Components/Table/table-style.scss';
import Dropdown from '../../Components/DropDown/drop-down.tsx';
import './vehicle.scss';
import ConfirmationModal from './confirmation-modal.tsx';
import OTPVerificationModal from './otp-verification-modal.tsx';
import CancelIcon from '@mui/icons-material/Cancel';
import AddNewModelModal from '../Devices/addNewModelModal.tsx';
import formatDate from '../../Utils/DateFormat/date-format.tsx';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

interface EditVehicleModalProps {
  open: boolean;
  onClose: () => void;
  vehicle: {
    id: any;
    number_plate: string;
    make_model: string;
    owner: string;
    driver: string;
    owner_phone: any;
    driver_phone: any;
    driver_id: string;
    fuel_type: string;
    active: number;
    companies_id?: any;
  } | null;
  tab: any;
}

interface Warehouse {
  id: number;
  name: string;
}

interface Institution {
  id: number;
  name: string;
  institution_name?: string;
}

interface Vendor {
  id: number;
  name: string;
}

const EditVehicleModal: React.FC<EditVehicleModalProps> = ({ open, onClose, vehicle, tab }) => {
  const [formValues, setFormValues] = useState({
    vehicle_no: '',
    model: '',
    owner: '',
    driver: '',
    driver_phone: '',
    fuel_type: '',
    owner_phone: ''
  });
  const [initialValues, setInitialValues] = useState(formValues);
  const [selectedInsuranceDate, setSelectedInsuranceDate] = useState<string>('');
  const [selectedFitnessDate, setSelectedFitnessDate] = useState<any>('');
  const [selectedRegistrationDate, setSelectedRegistrationDate] = useState<string>('');
  const [selectedPollutionDate, setSelectedPollutionDate] = useState<string>('');
  const [initialInsuranceDate, setInitialInsuranceDate] = useState<any>('');
  const [initialFitnessDate, setInitialFitnessDate] = useState<any>('');
  const [initialRegistrationDate, setInitialRegistrationDate] = useState<any>('');
  const [initialPollutionDate, setInitialPollutionDate] = useState<any>('');
  const [getFitnessDoc, setGetFitnessDoc] = useState<any>('');
  const [getInsuranceDoc, setGetInsuranceDoc] = useState<any>('');
  const [getRegistrationDoc, setGetRegistrationDoc] = useState<any>('');
  const [getPollutionDoc, setGetPollutionDoc] = useState<any>('');
  const [getInsuranceDate, setGetInsuranceDate] = useState<string | null>(null);
  const [getFitnessDate, setGetFitnessDate] = useState<string | null>(null);
  const [getRegistrationDate, setGetRegistrationDate] = useState<string | null>(null);
  const [getPollutionDate, setGetPollutionDate] = useState<string | null>(null);

  const [documentList, setDocumentList] = useState<any[]>([]);
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
  const [inactiveVehicle, setInactiveVehicle] = useState(false);
  const [documentToRemove, setDocumentToRemove] = useState<string | null>(null);
  const [ownerUserName, setOwnerUserName] = useState<string>('');
  const [isAddOwnerModalOpen, setIsAddOwnerModalOpen] = useState(false);
  const [driverUserName, setDriverUserName] = useState<string>('');
  const [ownerPhoneNumber, setOwnerPhoneNumber] = useState<string>('');
  const [driverPhoneNumber, setDriverPhoneNumber] = useState<string>('');
  const [documentDeleted, setDocumentDeleted] = useState(false);
  const [ownerId, setOwnerId] = useState<string>('');
  const [driverId, setDriverId] = useState<string>('');
  const [isOwnerFocused, setIsOwnerFocused] = useState<boolean>(false);
  const [isDriverFocused, setIsDriverFocused] = useState<boolean>(false);
  const [ownerError, setOwnerError] = useState<string | null>(null);
  const [driverError, setDriverError] = useState<string | null>(null);
  const [modelError, setModelError] = useState<string | null>(null);
  const [warehouseError, setWarehouseError] = useState<string | null>(null);
  const [documentLocation, setDocumentLocation] = useState<string | null>(null);
  const [documentId, setDocumentId] = useState<number | null>(null);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [fuelType, setFuelType] = useState<{ id: string; label: string }[]>([]);
  const [fuelName, setFuelName] = useState<string>('');
  const [warehouseData, setWarehouseData] = useState<Warehouse[]>([]);
  const [warehouses, setWarehouses] = useState<Warehouse[]>([]);
  const [selectedWarehouse, setSelectedWarehouse] = useState<{ id: string; label: string }[]>([]);
  const [warehouseId, setWarehouseId] = useState<{ user_warehouse_id: string; warehouse_id: string; label: string }[]>([]);
  const [isSTMSSelected, setIsSTMSSelected] = useState<boolean>(false);
  const [institutions, setInstitutions] = useState<Institution[]>([]);
  const [institutionData, setInstitutionData] = useState<Institution[]>([]);
  const [selectedInstitution, setSelectedInstitution] = useState<{ id: string; label: string }[]>([]);
  const [institutionMappingId, setInstitutionMappingId] = useState<{ mapping_id: string; institution_id: string; label: string }[]>([]);
  const [vendors, setVendors] = useState<Vendor[]>([]);
  const [isOTPModalOpen, setIsOTPModalOpen] = useState(false);
  const [modelOptions, setModelOptions] = useState<{ id: string; label: string }[]>([]);
  const [isAddNewModelModalOpen, setIsAddNewModelModalOpen] = useState(false);
  const [newModelValue, setNewModelValue] = useState("");
  const storedUserDetails = localStorage.getItem("userdetails");
  const userDetails = storedUserDetails ? JSON.parse(storedUserDetails) : null;
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [selectedAction, setSelectedAction] = useState<string>('');
  const isInactiveTab = vehicle?.active === 0;
  const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
  const companiesId = vehicle?.companies_id || localStorage.getItem('lastSelectedCompany') || userDetailsFromStorage?.companies_id || '';
  const maxDate = new Date();
  let otpVerified = '';
  let isOtpVerified = false;

  const [uploadFlow, setUploadFlow] = useState<{
    isOpen: boolean;
    docType: string;
    selectedDate: string;
  }>({ isOpen: false, docType: '', selectedDate: '' });

  const roleFeatures = JSON.parse(localStorage.getItem('roleFeatures') || '[]');
  const hasFeature = (featureName: string) => {
    if (!roleFeatures) return false;
    const target = featureName.toLowerCase();
    const containsFeature = (arr: any[]) => arr.some((f: any) => 
        (typeof f === 'string' && f.toLowerCase() === target) ||
        (f?.name && f.name.toLowerCase() === target) ||
        (f?.feature && f.feature.toLowerCase() === target)
    );

    if (Array.isArray(roleFeatures)) {
        const configObj = roleFeatures.find((item: any) => item && typeof item === 'object' && item.enabled);
        if (configObj) {
            if (configObj.enabled && Array.isArray(configObj.enabled) && containsFeature(configObj.enabled)) return true;
        }
        return containsFeature(roleFeatures);
    }

    if (typeof roleFeatures === 'object') {
        if (roleFeatures.enabled && Array.isArray(roleFeatures.enabled) && containsFeature(roleFeatures.enabled)) return true;
        return !!roleFeatures[featureName] || !!roleFeatures[target];
    }

    return false;
  };

  const hasWarehouseFeature = hasFeature('warehouse') || hasFeature('warehouses');
  const hasDriversFeature = hasFeature('drivers');
  const hasCompanyFeature = hasFeature('companies');

  const resetErrorMessages = () => {
    setOwnerError(null);
    setDriverError(null);
    setModelError(null);
    setWarehouseError(null);
    setErrorMessage(null);
    setSelectedInsuranceDate('');
    setGetFitnessDate('');
    setGetInsuranceDate('');
    setSelectedFitnessDate('');
    setSelectedRegistrationDate('');
    setGetRegistrationDate('');
    setSelectedPollutionDate('');
    setGetPollutionDate('');
    setSelectedWarehouse([]);
    setWarehouseData([]);
    setSelectedInstitution([]);
    setInstitutionData([]);
  };

  const handleClose = () => {
    resetErrorMessages();
    onClose();
  };

  const handleOwnerFocus = () => {
    setIsOwnerFocused(true);
    setOwnerUserName('');
  };

  const handleOwnerBlur = () => {
    if (ownerPhoneNumber.length === 10) {
      fetchDriverDetails(ownerPhoneNumber, 'owner');
    }
    setIsOwnerFocused(false);
  };

  const handleDriverFocus = () => {
    setIsDriverFocused(true);
  };

  const handleDriverBlur = () => {
    setIsDriverFocused(false);
  };

  const fuelTypeOptions = [
    { id: 'diesel', label: 'Diesel' },
    { id: 'EV', label: 'EV' },
    { id: 'petrol', label: 'Petrol' },
    { id: 'CNG', label: 'CNG' }
  ];

  const [selectedFiles, setSelectedFiles] = useState<{ [key: string]: File | null }>({
    registrationCertificate: null,
    pollutionCertificate: null,
    fitnessCertificate: null,
    insurance: null,
    drivers_license: null,
    aadhar: null
  });

  const [icons, setIcons] = useState<{ [key: string]: string }>({
    registrationcertificate: 'upload',
    pollutioncertificate: 'upload',
    fitnesscertificate: 'upload',
    insurance: 'upload'
  });

  const fetchDocuments = () => {
    if (vehicle?.id) {
      getDocuments(
        vehicle.id,
        (response: any) => {
          const documentDetails = response.message?.vehicle_documents || [];
          setDocumentList(documentDetails);
          const updatedDocuments = documentDetails.map((doc: any) => ({
            ...doc,
            expiry: doc.status === 'uploaded' ? doc.expiry || '' : ''
          }));
          const insuranceDoc = updatedDocuments.find((doc: any) =>
            doc.document_name.trim() === 'insurance' && doc.status === 'uploaded'
          );
          const fitnessDoc = updatedDocuments.find((doc: any) =>
            doc.document_name.trim() === 'fitness certificate' && doc.status === 'uploaded'
          );
          const registrationDoc = updatedDocuments.find((doc: any) =>
            doc.document_name.replace(' ', '').toLowerCase() === 'registrationcertificate' && doc.status === 'uploaded'
          );
          const pollutionDoc = updatedDocuments.find((doc: any) =>
            doc.document_name.replace(' ', '').toLowerCase() === 'pollutioncertificate' && doc.status === 'uploaded'
          );

          if (insuranceDoc) {
            setGetInsuranceDate(insuranceDoc.expiry);
            setInitialInsuranceDate(insuranceDoc.expiry);
            setGetInsuranceDoc(insuranceDoc);
          }
          if (fitnessDoc) {
            setGetFitnessDate(fitnessDoc.expiry);
            setInitialFitnessDate(fitnessDoc.expiry);
            setGetFitnessDoc(fitnessDoc);
          }
          if (registrationDoc) {
            setGetRegistrationDate(registrationDoc.expiry);
            setInitialRegistrationDate(registrationDoc.expiry);
            setGetRegistrationDoc(registrationDoc);
          }
          if (pollutionDoc) {
            setGetPollutionDate(pollutionDoc.expiry);
            setInitialPollutionDate(pollutionDoc.expiry);
            setGetPollutionDoc(pollutionDoc);
          }

          const newIcons: { [key: string]: string } = {
            registrationcertificate: 'upload',
            pollutioncertificate: 'upload',
            fitnesscertificate: 'upload',
            insurance: 'upload'
          };
          documentDetails.forEach((doc: { status: string; document_name: string; }) => {
            if (doc.status === 'uploaded') {
              newIcons[doc.document_name.replace(' ', '')] = 'view';
            }
          });
          setIcons(newIcons);
        },
        (errMessage: any) => {
          toast.error(errMessage);
        }
      );
    }
  };

  useEffect(() => {
    if (!open) return;

    getMakeModels(
      (response: any) => {
        if (response.status === 200 && response.data?.vehicle_models) {
          const mappedModels = response.data.vehicle_models
            .map((model: string) => ({ id: model, label: model }))
            .sort((a: any, b: any) => a.label.localeCompare(b.label));
          setModelOptions([...mappedModels, { id: 'ADD_NEW_MODEL_ACTION', label: '+ Add New Model' }]);
        }
      },
      (error: any) => toast.error(error?.message || "Failed to fetch vehicle models")
    );

    if (hasCompanyFeature) {
      getCompanies(100, 0, null, (res: any) => {
        const stms = res.message?.find((c: any) => c.company.name.toUpperCase() === 'STMS');
        const isStmsSelected = stms && String(stms.company.id) === localStorage.getItem('lastSelectedCompany');
        
        setIsSTMSSelected(!!isStmsSelected);
        
        if (isStmsSelected) {
          getInstitutions(100, 0, (instRes: any) => {
            const list = Array.isArray(instRes.data) ? instRes.data : [];
            setInstitutions(list);
          }, (err: any) => console.error("Failed to load institutions", err));
        } else if (hasWarehouseFeature) {
          getWarehouseCompanyMapping(companiesId, (response: any) => {
            setWarehouses(response.user_warehouses?.map((item: any) => item.warehouse) || []);
          }, (errMessage: any) => toast.error(errMessage.message));
        }
      }, () => {});
    } else if (hasWarehouseFeature) {
      getWarehouseCompanyMapping(companiesId, (response: any) => {
        setWarehouses(response.user_warehouses?.map((item: any) => item.warehouse) || []);
      }, (errMessage: any) => toast.error(errMessage.message));
    }
  }, [open, hasCompanyFeature, hasWarehouseFeature, companiesId]);

  useEffect(() => {
    if (open && vehicle?.id) {
      fetchDocuments();
    }
  }, [open, vehicle?.id]);
  

  useEffect(() => {
    if (!open || !vehicle) return;
    setDriverUserName(vehicle.driver || vehicle.driver_name || '');
    setDriverPhoneNumber(vehicle.driver_phone || '');
    setDriverId(vehicle.driver_id || '');
    setOwnerUserName(vehicle.owner || vehicle.owner_name || '');
    setOwnerPhoneNumber(vehicle.owner_phone || '');
    setOwnerId(vehicle.owner_id || '');

    setSelectedInstitution([]);
    setInstitutionData([]);
    setInstitutionMappingId([]);
    setSelectedWarehouse([]);
    setWarehouseData([]);
    setWarehouseId([]);

    setFormValues({
      vehicle_no: vehicle.number_plate || '',
      model: vehicle.make_model || '',
      owner: vehicle.owner || vehicle.owner_name || '',
      driver: vehicle.driver || vehicle.driver_name || '',
      driver_phone: vehicle.driver_phone || '',
      fuel_type: vehicle.fuel_type || '',
      owner_phone: vehicle.owner_phone || ''
    });

    setInitialValues({
      vehicle_no: vehicle.number_plate || '',
      model: vehicle.make_model || vehicle.make_model || '',
      owner: vehicle.owner || vehicle.owner_name || '',
      driver: vehicle.driver || vehicle.driver_name || '',
      driver_phone: vehicle.driver_phone || '',
      fuel_type: vehicle.fuel_type || '',
      owner_phone: vehicle.owner_phone || ''
    });

    if (vehicle?.id) {
      if (isSTMSSelected) {
        getInstitutionVehicleMapping([vehicle.id], '', 100, 0, (res: any) => {
          let mappings: any[] = [];
          if (res?.data && Array.isArray(res.data)) mappings = res.data;
          else if (Array.isArray(res)) mappings = res;
          else if (res?.data?.data && Array.isArray(res.data.data)) mappings = res.data.data;
          mappings = mappings.filter((m: any) => String(m.vehicle_id) === String(vehicle.id));
          if (mappings.length > 0) {
            const mapping = mappings[0];

            if (mapping.institution_id && mapping.institution_name) {
              const instObj = { id: String(mapping.institution_id), label: mapping.institution_name };
              setInstitutionData([{ id: mapping.institution_id, name: mapping.institution_name }]);
              setSelectedInstitution([instObj]);
            }

            setInstitutionMappingId([{
              mapping_id: mapping.id,
              institution_id: mapping.institution_id,
              label: mapping.institution_name
            }]);
            
            if (mapping.driver_name) setDriverUserName(mapping.driver_name);
            if (mapping.driver_number) {
              setDriverPhoneNumber(mapping.driver_number);
              setFormValues(prev => ({...prev, driver_phone: mapping.driver_number, driver: mapping.driver_name || prev.driver}));
            }
            if (mapping.driver_id) setDriverId(String(mapping.driver_id));
          }
        }, (err: any) => console.log(err));

      } else if (hasWarehouseFeature) {
        getWarehouseUserMapping(vehicle.driver_id, (response: any) => {
          const userWarehouses = response.user_warehouses?.map((mapping: any) => mapping.warehouse) || [];
          const mappingDetails = response.user_warehouses?.map((mapping: any) => ({
            user_warehouse_id: mapping.id,
            warehouse_id: mapping.warehouse.id,
            warehouse_name: mapping.warehouse.name
          })) || [];

          setWarehouseData(userWarehouses);
          setSelectedWarehouse(userWarehouses.map((wh: any) => ({ id: wh.id.toString(), label: wh.name })));
          setWarehouseId(mappingDetails);
        }, (errorMessage: any) => {
          setSelectedWarehouse([]);
          setWarehouseData([]);
        });
      }
    }
  }, [open, vehicle, isSTMSSelected, hasWarehouseFeature]);

  useEffect(() => {
    if (vehicle?.fuel_type) {
      const matchedOption = fuelTypeOptions.find(option => option.id === vehicle.fuel_type);
      if (matchedOption) {
        setFuelType([{ id: matchedOption.id.toString(), label: matchedOption.label }]);
      }
    }
  }, [vehicle?.fuel_type]);

  useEffect(() => {
    if (warehouseData && warehouses) {
      const matchedWarehouses = warehouses.filter(warehouse =>
        warehouseData.some(wh => wh.name === warehouse.name)
      );
      const newSelectedWarehouses = matchedWarehouses.map(warehouse => ({
        id: warehouse.id.toString(),
        label: warehouse.name
      }));

      setSelectedWarehouse(newSelectedWarehouses);
    }
  }, [warehouseData, warehouses]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const handleModelChange = (event: SelectChangeEvent<string>) => {
    const value = event.target.value;
    if (value === 'ADD_NEW_MODEL_ACTION') {
      setIsAddNewModelModalOpen(true);
    } else {
      setFormValues(prevValues => ({
        ...prevValues,
        model: value
      }));
      setModelError(null);
    }
  };

  const handleAddNewModelSubmit = () => {
    if (!newModelValue.trim()) {
      toast.error("Model name cannot be empty");
      return;
    }

    setModelOptions((prevOptions) => {
      const filteredOptions = prevOptions.filter(opt => opt.id !== 'ADD_NEW_MODEL_ACTION');
      const updatedModels = [
        ...filteredOptions,
        { id: newModelValue, label: newModelValue }
      ].sort((a, b) => a.label.localeCompare(b.label));
      return [
        ...updatedModels,
        { id: 'ADD_NEW_MODEL_ACTION', label: '+ Add New Model' }
      ];
    });

    setFormValues((prev) => ({ ...prev, model: newModelValue }));
    setModelError(null);

    setNewModelValue("");
    setIsAddNewModelModalOpen(false);
  };

  const handlePhoneNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
    validatePhoneNumber(value, name);
    if (name === 'driver') {
      setDriverPhoneNumber(value);
      if (value.length === 0 || value.length < 10) {
        setDriverUserName('');
        setWarehouseError('');
        setDriverId('');
        setSelectedInstitution([]);
      }
      if (value.length === 10) {
        fetchDriverDetails(value, 'driver');
      }
    } else {
      setOwnerPhoneNumber(value);
      if (value.length === 0 || value.length < 10) {
        setOwnerUserName('');
        setOwnerId('');
      }
      if (value.length === 10) {
        fetchDriverDetails(value, 'owner');
      }
    }
  };

  const uploadFile = (
    type: string, 
    file: File, 
    insuranceDate: string, 
    fitnessDate: string, 
    registrationDate: string, 
    pollutionDate: string, 
    action: string
  ) => {
    const commonCallback = (response: any) => {
      if (response.status === 200) {
        setSelectedFiles((prevFiles) => ({
          ...prevFiles,
          [type]: file
        }));
        setIcons((prevIcons) => ({
          ...prevIcons,
          [type]: 'view'
        }));
        toast.success("Document Uploaded Successfully");
        setErrorMessage(null);
        if (action === 'add') {
            setDocumentLocation(response?.message?.location);
            setDocumentId(response?.message?.id);
        }

        fetchDocuments();
      }
    };

    const commonErrorCallback = (errMessage: any) => {
      if (errMessage.status === 400) {
        let allErrorMessages: string[] = [];
        if (typeof errMessage.message === 'string') {
          allErrorMessages.push(errMessage.message);
          setSelectedFiles((prevFiles) => ({
            ...prevFiles,
            [type]: file
          }));
          setIcons((prevIcons) => ({
            ...prevIcons,
            [type]: 'view'
          }));
          toast.error(allErrorMessages.join(" "));
        }
        else if (errMessage.status === 413) {
          toast.error("Document Size is large");
        }
        else if (errMessage.message && typeof errMessage.message === 'object') {
          const errors = errMessage.message.errors || {};
          for (const [key, messages] of Object.entries(errors)) {
            if (Array.isArray(messages as any)) {
              allErrorMessages.push(...(messages as any));
            }
          }
          setSelectedFiles((prevFiles) => ({
            ...prevFiles,
            [type]: null
          }));
          setIcons((prevIcons) => ({
            ...prevIcons,
            [type]: 'upload'
          }));
          toast.error(allErrorMessages.join(" "));
        }
        if (allErrorMessages.length > 0) {
          setErrorMessage(allErrorMessages.join(" "));
        }
      }
    };

    if (action === 'add') {
      addDocuments(
        type === 'drivers_license' ? file : null,
        type === 'aadhar' ? file : null,
        type === 'registrationcertificate' ? file : null,
        type === 'insurance' ? file : null,
        type === 'fitnesscertificate' ? file : null,
        type === 'pollutioncertificate' ? file : null,
        vehicle?.id,
        fitnessDate,
        insuranceDate,
        registrationDate,
        pollutionDate,
        commonCallback,
        commonErrorCallback
      );
    } else {
      editDocuments(
        type === 'drivers_license' ? file : null,
        type === 'aadhar' ? file : null,
        type === 'registrationcertificate' ? file : null,
        type === 'insurance' ? file : null,
        type === 'fitnesscertificate' ? file : null,
        type === 'pollutioncertificate' ? file : null,
        vehicle?.id,
        fitnessDate,
        insuranceDate,
        registrationDate,
        pollutionDate,
        commonCallback,
        commonErrorCallback
      );
    }
  };

  const handleConfirmRemove = () => {
    if (vehicle?.active === 1 && !documentToRemove) {
      deleteVehicle(vehicle?.id, (response) => {
        toast.success(response.message)
        setInactiveVehicle(false);
        onClose();
      }, (errorMessage) => {
        toast.error(errorMessage.message)
      })
      setInactiveVehicle(false);
      setIsConfirmationOpen(false);
    }
    else if (vehicle?.active === 0 && !documentToRemove) {
      activateVehicle(vehicle?.id, (response) => { toast.success(response.message.error) }, (errorMessage) => { toast.error(errorMessage.message) })
      setInactiveVehicle(false);
      setIsConfirmationOpen(false);
      onClose();
    }
    else if (documentToRemove && vehicle?.id) {
      const document = documentList.find(doc =>
        doc.document_name.replace(' ', '').toLowerCase() === documentToRemove.toLowerCase() &&
        doc.status === 'uploaded'
      );
      const deleteCallback = (response: any) => {
        toast.success(response?.message);
        setSelectedFiles((prevFiles) => ({
          ...prevFiles,
          [documentToRemove]: null
        }));
        setIcons((prevIcons) => ({
          ...prevIcons,
          [documentToRemove]: 'upload'
        }));
        setDocumentLocation('');
        setSelectedInsuranceDate('');
        setGetInsuranceDate('');
        setSelectedFitnessDate('');
        setGetFitnessDate('');
        setSelectedRegistrationDate('');
        setGetRegistrationDate('');
        setSelectedPollutionDate('');
        setGetPollutionDate('');
        setErrorMessage('');
        setInitialInsuranceDate('');
        setInitialFitnessDate('');
        setInitialRegistrationDate('');
        setInitialPollutionDate('');  
        fetchDocuments();
      };
      
      const deleteErrorCallback = (errorMessage: any) => {
        toast.error(errorMessage.data.message);
      };

      if (documentId) {
        deleteDocument(documentId, vehicle?.id, deleteCallback, deleteErrorCallback);
      }
      else {
        deleteDocument(document?.id, vehicle?.id, deleteCallback, deleteErrorCallback);
      }
    }
    else {
      toast.error('Document not found.');
    }
    setDocumentToRemove(null);
    setIsConfirmationOpen(false);
  }

  const handleAddOwner = (name: string, phoneNumber: string, email: any, address: any, ifsc: any, accountNumber: any, remarks: any) => {
    addOwner(name, phoneNumber, (response) => {
      toast.success(response.message);
      setIsAddOwnerModalOpen(false)
      const ownerId = response.vehicle_owner.id;
      setOwnerId(ownerId);
      if (ownerId) {
        addOwnerDetails(ownerId, accountNumber, ifsc, remarks, email, address, (response) => {
          toast.success(response.message);
        },
          (errorMessage) => {
            toast.error(errorMessage);
          });
      }
    },
      (errorMessage) => {
        toast.error(errorMessage);
      })
    setOwnerUserName(name);
    setOwnerPhoneNumber(phoneNumber);
  };

  const handleVerifyOTP = (otp: string): Promise<{ success: boolean; message?: string }> => {
    return new Promise((resolve, reject) => {
      verifyOTP(
        driverPhoneNumber,
        '91',
        otp,
        (response) => {
          if (response.data.status === 200) {
            toast.success(response.data.message);
            otpVerified = '1';
            isOtpVerified = true;
            setIsOTPModalOpen(false);
            resolve({ success: true });
            handleSave();
          } else {
            resolve({ success: false, message: response.data.message || 'OTP verification failed.' });
          }
        },
        (errorMessage) => {
          resolve({ success: false, message: errorMessage });
        }
      );
    });
  };

  const handleCancelRemove = () => {
    setDocumentToRemove(null);
    setIsConfirmationOpen(false);
  };

  const validatePhoneNumber = (value: string, name: string) => {
    if (/[^0-9]/.test(value)) {
      if (name === 'owner') setOwnerError('Invalid Phone Number');
      else setDriverError('Invalid Phone Number');
      return;
    }
    if (value.length > 10) {
      if (name === 'owner') setOwnerError('Phone number cannot exceed 10 digits.');
      else setDriverError('Phone number cannot exceed 10 digits.');
      return;
    }
    if (value.length === 10) {
      if (name === 'owner') setOwnerError('');
      else setDriverError('');
      return;
    }
    if (/^[0-5]/.test(value)) {
      if (name === 'owner') setOwnerError('Phone number must start with 6,7,8,9');
      else setDriverError('Phone number must start with 6,7,8,9');
      return;
    }
    if (name === 'owner' && value === '') {
      setOwnerError('');
    } else if (name === 'driver' && value === '') {
      setDriverError('');
    }
  };

  const handleIconClick = (type: string, action: string) => {
    if (action === 'view' && (
      (type === 'fitnesscertificate' && (getFitnessDate || selectedFitnessDate)) || 
      (type === 'insurance' && (getInsuranceDate || selectedInsuranceDate)) ||
      (type === 'registrationcertificate' && (getRegistrationDate || selectedRegistrationDate)) ||
      (type === 'pollutioncertificate' && (getPollutionDate || selectedPollutionDate))
    )) {
      const document = documentList.find(doc => doc.document_name.replace(' ', '').toLowerCase() === type.toLowerCase() && doc.status === 'uploaded');
      if (document && !documentDeleted) {
        const url = document.location;
        window.open(`${global.documents_image_url}${url}`, '_blank');
      }
      else if (documentLocation) {
        const url = documentLocation;
        window.open(`${global.documents_image_url}${url}`, '_blank');
      }
      else {
        toast.error('Document not found.');
      }
    }
    else if (action === 'remove') {
      setDocumentToRemove(type);
      setIsConfirmationOpen(true);
      setDocumentDeleted(true);
    }
  };

  const fetchDriverDetails = (phoneNumber: string, name: string) => {
    if (phoneNumber.length < 10 && phoneNumber.length > 0) {
      if (name === 'owner') setOwnerError("Phone number must be 10 digits")
      else if (phoneNumber.length < 10 && phoneNumber.length > 0) setDriverError("Phone number must be 10 digits")
      else {
        setDriverError('');
        setOwnerError('');
      }
      return;
    }
    if (phoneNumber.length === 10) {
      if (name === 'owner') {
        getOwnerName(phoneNumber,
          (response: any) => {
            if (response.status === 200) {
              const user = response.message.vehicles_owners_list[0];
              setOwnerUserName(user.name);
              setOwnerPhoneNumber(user.phone);
              setOwnerId(user.id);
            }
          },
          (errMessage: any) => {
            if (errMessage.status === 404 || errMessage.message === "No Client Found") {
              setIsAddOwnerModalOpen(true);
              setOwnerId("");
              setOwnerUserName("");
            } else {
              setOwnerId("");
              setOwnerError("User Not found");
              setOwnerUserName("");
            }
          })
      }
      else {
        getDriverName(
          phoneNumber,
          (response: any) => {
            if (response.status === 200) {
              const user = response.message.user[0];
              setDriverUserName(user.user_name);
              setDriverPhoneNumber(user.user_phone);
              setDriverId(user.user_unique_id);
              
              if (isSTMSSelected) {
                getInstitutionVehicleMapping(
                  [],
                  user.user_unique_id,
                  100, 0,
                  (res: any) => {
                    let mappings: any[] = [];
                    
                    if (res?.data && Array.isArray(res.data)) mappings = res.data;
                    else if (Array.isArray(res)) mappings = res;
                    else if (res?.data?.data && Array.isArray(res.data.data)) mappings = res.data.data;
                    
                    if (mappings.length > 0) {
                      const mapping = mappings[0];
                      
                      if (mapping.institution_id && mapping.institution_name) {
                        const instObj = { id: String(mapping.institution_id), label: mapping.institution_name };
                        setInstitutionData([{ id: mapping.institution_id, name: mapping.institution_name }]);
                        setSelectedInstitution([instObj]);
                      }

                      console.log('Mapping details:', mapping);
                        setInstitutionMappingId(prev => [{
                          mapping_id: prev.length > 0 ? prev[0].mapping_id : "", 
                          institution_id: mapping.institution_id,
                          label: mapping.institution_name
                        }]);

                      if (mapping.driver_name) setDriverUserName(mapping.driver_name);
                      if (mapping.driver_number) {
                          setDriverPhoneNumber(mapping.driver_number);
                          setFormValues(prev => ({...prev, driver_phone: mapping.driver_number, driver: mapping.driver_name || prev.driver}));
                      }
                    } else {
                      setSelectedInstitution([]);
                      setInstitutionData([]);
                    }
                  },
                  (err: any) => {
                    setSelectedInstitution([]);
                    setInstitutionData([]);
                  }
                );
              } else if (hasWarehouseFeature) {
                getWarehouseUserMapping(
                  user.user_unique_id,
                  (res: any) => {
                    const userWarehouses = res.user_warehouses?.map((mapping: { warehouse: any; }) => mapping.warehouse) || [];
                    const mappingDetails = res.user_warehouses?.map((mapping: { id: any; warehouse: { id: any; name: any; }; }) => ({
                      user_warehouse_id: mapping.id,
                      warehouse_id: mapping.warehouse.id,
                      warehouse_name: mapping.warehouse.name
                    })) || [];

                    setWarehouseData(userWarehouses);
                    setSelectedWarehouse(userWarehouses.map((wh: { id: { toString: () => any; }; name: any; }) => ({
                      id: wh.id.toString(),
                      label: wh.name
                    })));
                    setWarehouseId(mappingDetails);
                  },
                  (errorMessage: any) => {
                    setSelectedWarehouse([]);
                    setWarehouseData([]);
                    if (errorMessage.status !== 404) {
                      toast.error(errorMessage);
                    }
                  }
                );
              }
            }
          },
          (errMessage: any) => {
            if (errMessage.status === 400) {
              if (errMessage.message.user.length === 0) {
                setDriverUserName('');
                setDriverError("User Not Found")
                setSelectedWarehouse([]);
                setWarehouseData([]);
                setSelectedInstitution([]);
                setInstitutionData([]);
              }
              else
                toast.error(errMessage.message);
            }
          }
        );
      }
    }
  };

  const hasWarehouseChanged = () => {
    if (!hasWarehouseFeature && !isSTMSSelected) return false;
    const currentWarehouseIds = selectedWarehouse.map(wh => wh.id);
    const previousWarehouseIds = warehouseData.map(wh => wh.id.toString());
    const addedWarehouses = currentWarehouseIds.filter(id =>
      !previousWarehouseIds.includes(id)
    );
    return addedWarehouses.length > 0;
  };

  const hasInstitutionChanged = () => {
    if (!isSTMSSelected) return false;
    const currentInstId = selectedInstitution.length > 0 ? selectedInstitution[0].id : null;
    const previousInstId = institutionData.length > 0 ? institutionData[0].id.toString() : null;
    return currentInstId !== previousInstId;
  };

  const addNewWarehouseMappings = () => {
    if (!hasWarehouseFeature) return;
    
    if (selectedWarehouse.length > 0) {
      const currentWarehouseIds = warehouseData.map(wh => wh.id.toString());
      const warehousesToAdd = selectedWarehouse.filter(
        wh => !currentWarehouseIds.includes(wh.id)
      );
      if (warehousesToAdd.length === 0) {
        handleClose();
        return;
      }

      const mappingPromises = warehousesToAdd.map(warehouse => {
        const warehouseId = parseInt(warehouse.id, 10);
        return new Promise((resolve, reject) => {
          addWarehouseUserMapping(
            driverId || vehicle?.driver_id,
            warehouseId,
            (mappingResponse) => {
              if (mappingResponse.data.status === 200) {
                toast.error(mappingResponse?.data?.message);
                resolve({ success: false, message: mappingResponse?.data?.message });
              } else if (mappingResponse.data.status === 201) {
                toast.success(mappingResponse.data.message);
                resolve({ success: true, message: mappingResponse.data.message });
              }
            },
            (errorMessage) => {
              if (errorMessage.status === 409) {
                console.log(errorMessage.message);
              } else {
                toast.error(errorMessage.message);
                reject(errorMessage);
              }
            }
          );
        });
      });

      Promise.all(mappingPromises)
        .then(results => {
          handleClose();
          console.log('New warehouse mappings completed', results);
        })
        .catch(error => {
          handleClose();
          console.error('Error in warehouse mappings:', error);
        });
    } else {
      handleClose();
    }
  };

  const saveInstitutionMappings = () => {
    if (!isSTMSSelected || selectedInstitution.length === 0) {
      return Promise.resolve(true);
    }

    const instId = parseInt(selectedInstitution[0].id, 10);
    const existingMapping = institutionMappingId[0];
    console.log('Saving institution mapping:', { vehicleId: vehicle?.id, driverId, instId, existingMapping });
    return new Promise((resolve, reject) => {
      if (existingMapping && existingMapping.mapping_id) {
        editInstitutionVehicleMapping(
          vehicle?.id, 
          driverId || vehicle?.driver_id,
          instId,
          existingMapping.mapping_id,
          (res: any) => resolve({ success: true, message: res?.message }),
          (err: any) => {
            toast.error(err?.message || 'Failed to update institution mapping');
            resolve(false);
          }
        );
      } else {
        addInstitutionVehicleMapping(
          driverId || vehicle?.driver_id,
          instId,
          vehicle?.id,
          (res: any) => resolve({ success: true, message: res?.message }),
          (err: any) => {
            toast.error(err?.message || 'Failed to add institution mapping');
            resolve(false);
          }
        );
      }
    });
  };

  const handleSave = () => {
    const changes = {
      model: formValues.model !== initialValues.model,
      driver: hasDriversFeature ? (driverPhoneNumber !== vehicle?.driver_phone) : false,
      owner: ownerPhoneNumber !== vehicle?.owner_phone,
      fuel_type: (fuelType[0]?.id || '') !== vehicle?.fuel_type,
      warehouse: hasWarehouseFeature ? hasWarehouseChanged() : false,
      institution: isSTMSSelected ? hasInstitutionChanged() : false
    };
    
    const otherFieldsChanged = changes.model || changes.owner || changes.fuel_type;
    const isDriverFilled = formValues.driver || driverPhoneNumber;
    const isWarehouseFilled = isSTMSSelected ? selectedInstitution.length > 0 : selectedWarehouse.length > 0;
    const isOwnerFilled = ownerUserName && ownerUserName.trim() !== ''; 
    
    if (isInactiveTab) {
      toast.error("Inactive vehicle can't be edited");
      return;
    }


    if (hasWarehouseFeature && isDriverFilled && !isWarehouseFilled && !isSTMSSelected) {
      setWarehouseError('Warehouse is required');
      return;
    }

    if (hasDriversFeature && hasWarehouseFeature && !isDriverFilled && isWarehouseFilled && !isSTMSSelected) {
      setDriverError('Driver is required');
      return;
    }

    if (!formValues.model) {
      setModelError('This field is required.');
      return;
    }

    if (ownerError || driverError || modelError || errorMessage) {
      toast.error('Please fix the errors before saving.');
      return;
    }

    if (!otherFieldsChanged && !changes.driver && !changes.warehouse && !changes.institution) {
      if (isSTMSSelected && institutionMappingId.length > 0) {
        saveInstitutionMappings().then(() => {
          console.log('Institution mapping synced successfully');
          toast.success("Mapping synced successfully");
          handleClose();
        });
      } else {
        toast.info("No changes detected.");
      }
      return;
    }

    const finalModel = changes.model ? formValues.model : (vehicle?.make_model || '');
    const finalDriverId = driverId || vehicle?.driver_id || '';
    const finalOwnerId = ownerId || vehicle?.owner_id || '';
    const finalFuelType = fuelType.length > 0 ? fuelType[0].id : (vehicle?.fuel_type || '');

    editVehicle(
      finalModel, 
      vehicle?.number_plate || '', 
      finalDriverId, 
      finalOwnerId, 
      finalFuelType, 
      otpVerified, 
      '', 
      '', 
      companiesId,
      (response) => {
        const isOtpSent = response?.data?.message?.includes('OTP');
        
        if (isOtpSent || response.status !== 200) {
          handleVehicleEditResponse(response, false);
          return;
        }

        handleVehicleEditResponse(response, false);

        if (isSTMSSelected) {
          console.log('Saving institution mappings...');
          saveInstitutionMappings().then(() => handleClose());
        } else {
          if (changes.warehouse || changes.driver) {
            addNewWarehouseMappings();
          } else {
            handleClose();
          }
        }
      },
      (errorMessage) => {
        if (errorMessage.status === 400) {
          if (errorMessage.message.error === "Confirmation required") {
            setIsConfirmationModalOpen(true);
          }
          else if (errorMessage.message.error === "Re-confirmation required") {
            setSelectedAction('reconfirm');
            setIsConfirmationModalOpen(true);
          }
        }
        toast.error(errorMessage.message);
      }
    );
  };

  const handleVehicleEditResponse = (response: any, shouldClose: boolean = false) => {
    if (response.status === 200) {
      if (response?.data?.status === 308) {
        toast.error(response.data.message);
      } else if (response?.data?.status === 400) {
        toast.error("Please contact your administrator");
      } else if (
        response?.data?.message === 'OTP sent.' ||
        response?.data?.message === 'Old OTP expired. New OTP generated and re-sent.' ||
        response?.data?.message === 'OTP re-sent.'
      ) {
        setIsOTPModalOpen(true);
        return;
      } else {
        toast.success(response?.message?.message);
        isOtpVerified = true;

        if (shouldClose) {
          handleClose();
        }
      }
    } else {
      toast.error(response?.message || 'An error occurred');
    }
  };

  const isValidFileType = (file: File, allowedTypes: string[]) => {
    return allowedTypes.includes(file.type);
  };

  const handleConfirmationAction = (action: string) => {
    setIsConfirmationModalOpen(false);
    const driverStatus = action === '1' ? 1 : action === '2' ? 2 : 3;
    const switchReconfirm = action === '1' ? 1 : '';
    
    editVehicle(
      formValues.model, vehicle?.number_plate || '', driverId || vehicle?.driver_id || '', ownerId || vehicle?.owner_id || '', fuelType[0]?.id || '', otpVerified, driverStatus, switchReconfirm, companiesId,
      (response) => {
        const isOtpSent = response?.data?.message?.includes('OTP');
        
        if (isOtpSent || response.status !== 200) {
          handleVehicleEditResponse(response, false);
          return;
        }

        handleVehicleEditResponse(response, false);

        if (isSTMSSelected) {
          saveInstitutionMappings().then(() => handleClose());
        } else {
          if (selectedWarehouse.length > 0 || driverId !== vehicle?.driver_id) {
            addNewWarehouseMappings();
          } else {
            handleClose();
          }
        }
      },
      (errorMessage) => {
        toast.error(errorMessage.message);
        if (errorMessage.status === 400) {
          if (errorMessage.message.error === "Confirmation required") {
            setIsConfirmationModalOpen(true);
          }
          else if (errorMessage.message.error === "Re-confirmation required") {
            setSelectedAction('reconfirm');
            setIsConfirmationModalOpen(true);
          }
        }
      }
    );
  };

  const triggerUploadFlow = (type: string) => {
    setUploadFlow({ isOpen: true, docType: type, selectedDate: '' });
  };

  const handleDateSelected = (date: string) => {
    setUploadFlow(prev => ({ ...prev, isOpen: false, selectedDate: date }));
    
    setTimeout(() => {
      const fileInput = document.getElementById(`${uploadFlow.docType}-file`) as HTMLInputElement;
      if (fileInput) {
        fileInput.click();
      }
    }, 150); 
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>, type: string) => {
    const fileInput = event.target;
    const file = event.target.files?.[0] || null;
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];
    const maxFileSize = 1 * 1024 * 1024;
    
    if (!file) {
      toast.error('No file selected. Please choose a file to upload.');
      return;
    }
    if (!isValidFileType(file, allowedTypes)) {
      toast.error('Invalid file type. Please upload a jpeg, jpg, png, or pdf file.');
      return;
    }
    if (file.size > maxFileSize) {
      toast.error('File size exceeds 1 MB. Please upload a smaller file.');
      return;
    }

    setSelectedFiles((prevFiles) => ({ ...prevFiles, [type]: file }));
    setIcons((prevIcons) => ({ ...prevIcons, [type]: 'upload' }));

    if (vehicle?.id && file) {
      const flowDate = uploadFlow.selectedDate;

      if (type === 'fitnesscertificate' && !flowDate && !selectedFitnessDate) {
        setErrorMessage('Expiry date is required for Fitness Certificate');
        setIcons((prevIcons) => ({ ...prevIcons, [type]: 'view' }));
      } else if (type === 'insurance' && !flowDate && !selectedInsuranceDate) {
        setErrorMessage('Expiry date is required for Insurance Certificate');
        setIcons((prevIcons) => ({ ...prevIcons, [type]: 'view' }));
      } else if (type === 'registrationcertificate' && !flowDate && !selectedRegistrationDate) {
        setErrorMessage('Date is required for Registration Certificate');
        setIcons((prevIcons) => ({ ...prevIcons, [type]: 'view' }));
      } else if (type === 'pollutioncertificate' && !flowDate && !selectedPollutionDate) {
        setErrorMessage('Date is required for Pollution Certificate');
        setIcons((prevIcons) => ({ ...prevIcons, [type]: 'view' }));
      } else {
        setErrorMessage('');
        
        const fitnessDate = type === 'fitnesscertificate' ? flowDate : selectedFitnessDate;
        const insuranceDate = type === 'insurance' ? flowDate : selectedInsuranceDate;
        const registrationDate = type === 'registrationcertificate' ? flowDate : selectedRegistrationDate;
        const pollutionDate = type === 'pollutioncertificate' ? flowDate : selectedPollutionDate;

        if (type === 'fitnesscertificate') setSelectedFitnessDate(fitnessDate);
        if (type === 'insurance') setSelectedInsuranceDate(insuranceDate);
        if (type === 'registrationcertificate') setSelectedRegistrationDate(registrationDate);
        if (type === 'pollutioncertificate') setSelectedPollutionDate(pollutionDate);

        uploadFile(type, file, insuranceDate, fitnessDate, registrationDate, pollutionDate, 'add');
      }
    }
    fileInput.value = '';
    setUploadFlow({ isOpen: false, docType: '', selectedDate: '' });
  };

  const warehouseOptions = warehouses.map((warehouse) => ({
    id: warehouse.id.toString(),
    label: warehouse.name,
  }));

 const institutionOptions = institutions.map((institution: any) => ({
  id: institution.id.toString(),
  label: institution.institution_name || institution.name,
}));

  const handleFuelTypeChange = (event: SelectChangeEvent<string>) => {
    const selectedId = event.target.value;
    setFuelName(selectedId);
    const selectedOption = fuelTypeOptions.find(option => option.id === selectedId);
    if (selectedOption) {
      setFuelType([selectedOption]);
    } else {
      setFuelType([]);
    }
  };

  const handleInstitutionSelectionChange = (event: SelectChangeEvent<string>) => {
    const selectedId = event.target.value;
    const newSelectedInstitution = institutionOptions.find(option => option.id === selectedId);
    if (newSelectedInstitution) {
      setSelectedInstitution([newSelectedInstitution]);
    } else {
      setSelectedInstitution([]);
    }
  };

  const handleWarehouseSelectionChange = (event: SelectChangeEvent<string>) => {
    const selectedIds = event.target.value as string[];
    const removedWarehouses = selectedWarehouse.filter(
      wh => !selectedIds.includes(wh.id)
    );
    const addedWarehouses = selectedIds.filter(
      id => !selectedWarehouse.some(wh => wh.id === id)
    );
    removedWarehouses.forEach(warehouse => {
      const mapping = warehouseId.find(
        wh => wh.warehouse_id.toString() === warehouse.id
      );

      if (mapping) {
        const userWarehouseId = mapping.user_warehouse_id;

        deleteUserWarehousemapping(
          userWarehouseId,
          (response) => {
            if (response.status === 200) {
              toast.success(`Warehouse ${warehouse.label} removed successfully`);
              setWarehouseData(prev =>
                prev.filter(wh => wh.id.toString() !== warehouse.id)
              );
              setSelectedWarehouse(prev =>
                prev.filter(wh => wh.id !== warehouse.id)
              );
            }
          },
          (error) => {
            toast.error(`Failed to remove warehouse ${warehouse.label}: ${error.message}`);
            setSelectedWarehouse(prev => [...prev, warehouse]);
          }
        );
      }
    });

    const newSelectedWarehouses = warehouseOptions.filter(option =>
      selectedIds.includes(option.id)
    );
    setSelectedWarehouse(newSelectedWarehouses);
    setWarehouseError('');
  };

  const renderFileInput = (label: string, type: string) => {
    const requiresDate = ['insurance', 'fitnesscertificate', 'registrationcertificate', 'pollutioncertificate'].includes(type);
    
    const hasUploadedDate = type === 'insurance' ? getInsuranceDate : 
                            type === 'fitnesscertificate' ? getFitnessDate : 
                            type === 'registrationcertificate' ? getRegistrationDate : 
                            type === 'pollutioncertificate' ? getPollutionDate : null;

    const dateLabel = type === 'registrationcertificate' ? 'Registration Date: ' :
                      type === 'pollutioncertificate' ? 'Pollution Date: ' :
                      'Expiry Date: ';
  
    return (
      <Paper 
        elevation={0} 
        sx={{ 
          display: 'flex', 
          flexDirection: 'column',
          p: 1, 
          mb: 1.5, 
          border: '1px solid #e0e0e0', 
          borderRadius: '8px',
          backgroundColor: '#fafafa',
          width: '100%'
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', minHeight: '40px' }}>
          <Typography variant="body2" fontWeight="500">
            {label}
          </Typography>
  
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
            <input
              accept="image/jpeg, image/jpg, image/png, application/pdf"
              style={{ display: 'none' }}
              id={`${type}-file`}
              type="file"
              onChange={(e) => handleFileChange(e, type)}
              disabled={isInactiveTab}
            />
            
            <Tooltip title="Upload File">
              <IconButton 
                color="primary" 
                onClick={() => {
                  if (requiresDate) {
                    triggerUploadFlow(type);
                  } else {
                    document.getElementById(`${type}-file`)?.click();
                  }
                }}
                disabled={isInactiveTab}
              >
                {icons[type] === 'upload' && !isInactiveTab && <UploadIcon />}
              </IconButton>
            </Tooltip>
  
            {icons[type] === 'view' && (
              <>
                <Tooltip title="View File">
                  <IconButton sx={{ color: 'black' }} onClick={() => handleIconClick(type, 'view')}>
                    <VisibilityIcon />
                  </IconButton>
                </Tooltip>
                {!isInactiveTab && (
                  <Tooltip title="Remove File">
                    <IconButton sx={{ color: 'red' }} onClick={() => handleIconClick(type, 'remove')}>
                      <DeleteIcon />
                    </IconButton>
                  </Tooltip>
                )}
              </>
            )}
          </Box>
        </Box>
  
        {/* Bottom Row: Display Date after upload */}
        {requiresDate && hasUploadedDate && icons[type] === 'view' && (
          <Box sx={{ width: '100%', mt: 0.5 }}>
            <Typography variant="caption" color="text.secondary">
              {dateLabel} {formatDate(hasUploadedDate)}
            </Typography>
          </Box>
        )}
      </Paper>
    );
  };

  const labelStyle = { margin: 0, fontSize: '15px', fontWeight: 500, color: '#333' };

  return (
    <Dialog open={open} onClose={handleClose} PaperProps={{ sx: { width: '650px', maxWidth: '100%', height: 'auto' } }}>
      {/* HEADING SECTION WITH DEACTIVATION ICON */}
      <Box
        sx={{
          marginLeft: {
            xs: '0px',
            sm: '-180px',
          },
        }}
      >
        <Heading 
          title={
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span>{formValues?.vehicle_no}</span>
              <Tooltip title={vehicle?.active === 0 ? "Activate" : "Deactivate"}>
                <IconButton
                  size="small"
                  onClick={() => {
                    setIsConfirmationOpen(true);
                    setInactiveVehicle(true);
                  }}
                  sx={{
                    flexShrink: 0,
                    padding: '4px',
                  }}
                >
                 {vehicle?.active === 0 ? (
                    <PowerSettingsNewIcon 
                      sx={{
                        fontSize: '1.5rem', 
                        color: '#4caf50',
                        '&:hover': {
                          color: '#388e3c'
                        }
                      }}
                    />
                  ) : (
                    <DeleteIcon 
                      sx={{
                        fontSize: '1.5rem', 
                        color: '#e50000', 
                        '&:hover': {
                          color: '#b71c1c'
                        }
                      }}
                    />
                  )}
                </IconButton>
              </Tooltip>
            </Box>
          } 
          closeIcon="true" 
          onClose={handleClose} 
        />
      </Box>

      <DialogContent>
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: '16px', alignItems: 'start' }}>
          
          <Box sx={{ width: '248px' }}>
            <Dropdown
              options={modelOptions}
              selectedValue={formValues.model}
              handleChange={handleModelChange}
              placeholder="Select Model"
              label="Select Model"
              width="248px"
              height="40px"
              error={!!modelError}
              helperText={modelError}
              disabled={isInactiveTab}
              searchable={true}
            />
          </Box>

          <TextField
            size="small"
            sx={{ width: '248px' }}
            label={ownerUserName ? 'Owner Name' : 'Owner Phone Number'}
            placeholder="Owner Phone Number"
            name="owner"
            value={isOwnerFocused ? ownerPhoneNumber : ownerUserName || ownerPhoneNumber}
            onChange={handlePhoneNumberChange}
            error={!!ownerError}
            helperText={ownerError}
            onFocus={handleOwnerFocus}
            onBlur={handleOwnerBlur}
            disabled={isInactiveTab}
          />

          {hasDriversFeature && (
            <TextField
              label={driverUserName ? 'Driver Name' : 'Driver Phone Number'}
              size="small"
              name="driver"
              placeholder="Driver Phone Number"
              value={(isDriverFocused ? driverPhoneNumber : driverUserName || driverPhoneNumber) || ''}
              onChange={handlePhoneNumberChange}
              onFocus={handleDriverFocus}
              onBlur={handleDriverBlur}
              error={!!driverError}
              helperText={driverError}
              sx={{ width: '248px' }}
              disabled={isInactiveTab}
            />
          )}

          <Box sx={{ width: '190px' }}>
            <Dropdown
              options={fuelTypeOptions}
              selectedValue={fuelType.length > 0 ? fuelType[0].id : ''}
              handleChange={handleFuelTypeChange}
              placeholder="Select Fuel"
              label="Select Fuel Type"
              width="248px"
              height="40px"
              disabled={isInactiveTab}
            />
          </Box>

          {hasWarehouseFeature && !isSTMSSelected && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', width: '247px' }}>
              <FormControl sx={{ flexGrow: 1, width: '100%' }} error={!!warehouseError} disabled={isInactiveTab}>
                <InputLabel shrink={true} sx={{ backgroundColor: 'background.paper', px: 1, zIndex: 1 }} id="warehouse-multiple-label">
                  Warehouse
                </InputLabel>
                <Select
                  labelId="warehouse-multiple-label"
                  id="warehouse-multiple"
                  multiple
                  size="small"
                  value={selectedWarehouse.map((wh) => wh.id)}
                  onChange={handleWarehouseSelectionChange}
                  renderValue={(selected) => (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                      {selected.map((value) => {
                        const warehouse = warehouseOptions.find((wh) => wh.id === value);
                        return warehouse ? (
                          <Chip
                            key={warehouse.id}
                            label={warehouse.label}
                            size="small"
                            onDelete={(e) => {
                              e.stopPropagation();
                              const mapping = warehouseId.find((wh) => wh.warehouse_id.toString() === warehouse.id);
                              if (mapping) {
                                const userWarehouseId = mapping.user_warehouse_id;
                                deleteUserWarehousemapping(
                                  userWarehouseId,
                                  (response) => {
                                    if (response.status === 200) {
                                      toast.success(`Warehouse ${warehouse.label} removed successfully`);
                                      setWarehouseData((prev) => prev.filter((wh) => wh.id.toString() !== warehouse.id));
                                      setSelectedWarehouse((prev) => prev.filter((wh) => wh.id !== warehouse.id));
                                    }
                                  },
                                  (error) => {
                                    toast.error(`Failed to remove warehouse ${warehouse.label}: ${error.message}`);
                                    setSelectedWarehouse((prev) => [...prev, warehouse]);
                                  }
                                );
                              }
                            }}
                            deleteIcon={<CancelIcon onMouseDown={(event) => event.stopPropagation()} />}
                          />
                        ) : null;
                      })}
                    </Box>
                  )}
                >
                  {warehouseOptions.map((option) => (
                    <MenuItem key={option.id} value={option.id}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
                {warehouseError && (
                  <p style={{ color: '#d32f2f', fontSize: '0.70rem', margin: '3px 0 0' }}>
                    {warehouseError}
                  </p>
                )}
              </FormControl>
            </Box>
          )}

          {isSTMSSelected && (formValues.driver || driverPhoneNumber) && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', width: '247px' }}>
              <FormControl sx={{ flexGrow: 1, width: '100%' }} disabled={isInactiveTab}>
                <InputLabel shrink={true} sx={{ backgroundColor: 'background.paper', px: 1, zIndex: 1 }} id="institution-label">
                  Institution
                </InputLabel>
                <Select
                  labelId="institution-label"
                  id="institution-select"
                  size="small"
                  value={selectedInstitution.length > 0 ? selectedInstitution[0].id : ''}
                  onChange={handleInstitutionSelectionChange}
                >
                  {institutionOptions.map((option) => (
                    <MenuItem key={option.id} value={option.id}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          )}
        </Box>

        {/* ACCORDION FOR CERTIFICATES */}
        <Box sx={{ mt: 0 }}>
          <Accordion 
            elevation={0} 
            sx={{ 
              border: '1px solid #e0e0e0', 
              borderRadius: '8px',
              '&:before': { display: 'none' },
              marginBottom:'10px',
              marginTop:'10px' 
            }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />} id="certificates-header">
              <Typography variant="subtitle1" fontWeight="bold">
                Documents
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                {renderFileInput('Registration', 'registrationcertificate')}
                {renderFileInput('Pollution', 'pollutioncertificate')}
                {renderFileInput('Fitness', 'fitnesscertificate')}
                {renderFileInput('Insurance', 'insurance')}
              </Box>
            </AccordionDetails>
          </Accordion>
        </Box>

        {errorMessage && (
          <div style={{ color: 'red', marginTop: '10px', fontSize: '15px' }}>
            {errorMessage}
          </div>
        )}
      </DialogContent>

{!isInactiveTab && (
        <DialogActions style={{ display: 'flex', justifyContent: 'center', paddingBottom: '16px' }}>
          <Button className="custom-cancel-button" onClick={handleClose}>
            Cancel
          </Button>
           <Button className="custom-button" onClick={handleSave}>
            Save
          </Button>
        </DialogActions>
      )}

      <ConfirmationPopup
        open={isConfirmationOpen}
        onClose={handleCancelRemove}
        onConfirm={handleConfirmRemove}
        title="Confirm Action"
        message={
          inactiveVehicle
            ? (vehicle?.active === 0
              ? <>Are you sure you want to <strong>activate</strong> the vehicle?</>
              : <>Are you sure you want to <strong>deactivate</strong> the vehicle?</>)
            : "Are you sure you want to remove this file?"
        }
      />
      <AddOwnerModal
        isOpen={isAddOwnerModalOpen}
        handleClose={() => setIsAddOwnerModalOpen(false)}
        phoneNumber={ownerPhoneNumber}
        onAddOwner={handleAddOwner}
      />
      <OTPVerificationModal
        isOpen={isOTPModalOpen}
        handleClose={() => setIsOTPModalOpen(false)}
        phoneNumber={driverPhoneNumber}
        handleVerifyOTP={handleVerifyOTP}
      />
      <ConfirmationModal
        isOpen={isConfirmationModalOpen}
        onClose={() => setIsConfirmationModalOpen(false)}
        onConfirm={handleConfirmationAction}
      />
      <AddNewModelModal
        open={isAddNewModelModalOpen}
        title="Add New Vehicle Model"
        value={newModelValue}
        onChange={setNewModelValue}
        onClose={() => {
          setIsAddNewModelModalOpen(false);
          setNewModelValue("");
        }}
        onSubmit={handleAddNewModelSubmit}
      />

<Dialog 
        open={uploadFlow.isOpen} 
        onClose={() => setUploadFlow(prev => ({ ...prev, isOpen: false }))}
        PaperProps={{
          sx: {
            margin: { xs: '10px', sm: '32px' }, 
            maxWidth: '100%',
            overflowX: 'hidden' 
          }
        }}
      >
        <Box sx={{ 
          p: { xs: 1, sm: 2 }, 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center' 
        }}>
          <Typography variant="subtitle1" sx={{ mb: { xs: 1, sm: 2 }, textAlign: 'center', fontWeight: 'bold' }}>
            Select Date
          </Typography>
          
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Box sx={{ 
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              transform: { xs: 'scale(0.85)', sm: 'scale(1)' }, 
              transformOrigin: 'top center',
              mb: { xs: -4, sm: 0 } 
            }}>
              <DateCalendar 
                value={uploadFlow.selectedDate ? new Date(uploadFlow.selectedDate) : null}
                onChange={(newValue) => {
                  if (newValue) {
                    const formattedDate = newValue.toISOString().split('T')[0];
                    setUploadFlow(prev => ({ ...prev, selectedDate: formattedDate }));
                  }
                }} 
              />
            </Box>
          </LocalizationProvider>
        </Box>

        {/* ADDED: Action buttons so the user isn't kicked out early */}
         <DialogActions style={{ display: 'flex', justifyContent: 'center', paddingBottom: '16px' }}>
          <Button 
            onClick={() => setUploadFlow(prev => ({ ...prev, isOpen: false, selectedDate: '' }))} 
            className="custom-cancel-button"
          >
            Cancel
          </Button>
          <Button 
            variant="contained" 
           className="custom-button"
            disabled={!uploadFlow.selectedDate}
            onClick={() => {
              if (uploadFlow.selectedDate) {
                handleDateSelected(uploadFlow.selectedDate);
              }
            }}
          >
            Confirm & Upload
          </Button>
        </DialogActions>
      </Dialog>
    </Dialog>
  );
};

export default EditVehicleModal;